import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import {Tabs, Tab, Stack, Snackbar, Alert, Dialog, DialogActions, DialogContentText} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Radio from '@mui/material/Radio';
///import Tooltip from '@mui/material/Tooltip';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import 'font-awesome/css/font-awesome.min.css';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [uploadProgress, setUploadProgress] = React.useState(false);
  const [tabValue, setTabValue] = React.useState(0);
  const [selectedRow, setSelectedRow] = React.useState(0);
  const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);
  const [browseFilePath, setBrowseFilePath] = React.useState("");

  function deleteDialogHide(){
		setDeleteDialogShow(false);
	}
  
  const columns = [
		{
			field: "Select",
			headerName: "",
      renderHeader: () => (
        <span style={{lineHeight:1}}>
          Select<br/><span style={{fontSize:9}}>Click on radio button</span>
        </span>
        ),
			width: 110,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'id', headerName: '#', width: 40 },
		{ field: 'fileName', headerName: 'File Name', width: 200, renderCell: (params) =>  (
			params.row.fileTyp==='Image'?<span><img src={params.row.virtualUrl+'/'+params.row.fileName} style={{height:50}} /></span>:params.row.fileType==='pdf'?<span><img src='/pdf.png' style={{height:50}} /></span>:(params.row.fileType==='ppt' || params.row.fileType==='pptx')?<span><img src='/ppt.png' style={{height:50}} /></span>:(params.row.fileType==='doc' || params.row.fileType==='docx')?<span><img src='/doc.png' style={{height:50}} /></span>:(params.row.fileType==='xls' || params.row.fileType==='xlsx')?<span><img src='/xls.png' style={{height:50}} /></span>:<span><img src='/blank.png' style={{height:50}} /></span>
		   ), },		
		{ field: 'fileType', headerName: 'File Type', width: 125 },
    { field: 'fileSize', headerName: 'Size', width: 120 },
    { field: 'addedDateTime', headerName: 'Added Date/Time', width: 150, renderCell: (params) =>  (
			  <span>{params.value} <i class="fa fa-trash-o" style={{color:'red'}} ></i></span>
		   ), },		
	  ];

    

  const handleTabChange = (event, val) => {
    setTabValue(val);
  };


  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  React.useEffect(() => {		
		if(open && browseFilePath){
			upload();
		}
	}, [browseFilePath,open]);

  function upload(){
		if(browseFilePath && browseFilePath.length>1){ 
      setUploadProgress(true);
      let axiosHeader = {
				headers: {
          'Content-Type': 'multipart/mixed',
            'device': 'web',
            'uid': userObj.loginId,
            'fullName': userObj.fullName,
            'token': userObj.token,
        }
			}; 
			const data = new FormData();
      var myFile = document.querySelector('#selectedfileid');
      if(myFile.files[0]){
        data.append("uploadedFiles", myFile.files[0]);
      }

      let apiURL='/admin-upload-files-allied';
      let myMessage="File has been uploaded.";
                   
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setUploadProgress(false);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage(myMessage);
          setBrowseFilePath("");
          setTabValue(0);	
					return false;
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("File could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})	
		}		
	}

  React.useEffect(() => {		
		if(open && userObj.loginId && userObj.token){
			getApiData();
		}
	}, [userObj,open,tabValue]);

  // React.useEffect(() => {		
	// 	if(open && userObj.emailId && userObj.token && tabValue===0){
	// 		getApiData(userObj.emailId,userObj.token);
	// 	}
	// }, [userObj,open,tabValue]);

	async function getApiData(){
      let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
            'device': 'web',
            'uid': userObj.loginId,
            'fullName': userObj.fullName,
            'token': userObj.token,
        }
      }; 

			axios.get(API_URL+'/admin-list-files-allied',axiosHeader)
			   .then(response => {	
				if(response.data && response.data.responseTxt==="success"){
					setRows(response.data.obj);
				} 				
			})
	}

  function deleteData(){
		if(dataObj){
			let axiosHeader = {
				headers: {
          'Content-Type': 'multipart/mixed',
            'device': 'web',
            'uid': userObj.loginId,
            'fullName': userObj.fullName,
            'token': userObj.token,
        }
			};

		  const data = new FormData();
		  data.append('id', dataObj.autoId);
				 
		  axios.post(API_URL+'/admin-delete-files-allied', data, axiosHeader)
				.then((response) => {
					//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data && response.data.responseTxt==="InvalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data.responseTxt==="success"){
          if(userObj.token){
            getApiData();
          }
          deleteDialogHide();
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("File has been deleted.");
					return false;
				}else{
          deleteDialogHide();
			  	setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("File could not be deleted.");			
					return false;
				}
			}).catch((error) => {
					setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
				})	
		}		
		
	}


  const handleOnCellClick = (obj) => { 
		if(obj.field==='Select'){
      if(obj && rows[obj.id-1]){			
        ///setSelectedRow(rows[obj.id-1].id);
        setSelectedRow(0);  
        setDataObj({});
        props.setFileData(rows[obj.id-1]);      
        handleClose();
      }
    }else if(obj.field==='fileName'){ 
        if(obj && rows[obj.id-1]){
          window.open(rows[obj.id-1].virtualUrl+'/'+rows[obj.id-1].fileName);
        }
		}else if(obj.field==='addedDateTime'){
			setDeleteDialogShow(true);
      setDataObj(rows[obj.id-1]);
		}	
	};

 
  // function selectRow(obj){
  //   if(obj && rows[obj.id-1]){			
  //     setSelectedRow(rows[obj.id-1].id);
  //     ///setDataObj(rows[obj.id-1]);
  //   }
  // }
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:'88vh'}}>
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>Files</h3></div>
                  <p>

                      <Box sx={{ marginTop:-20, width: '100%', bgcolor: 'background.paper' }}>
                        <Tabs value={tabValue} onChange={handleTabChange} centered>
                          <Tab label="Asset Library" />
                          <Tab label="Upload" />
                        </Tabs>
                      </Box>
                    {/* UPLOAD FILE */}
                    {tabValue===1?
                      <Box style={{textAlign:'center'}} >
                        <hr />
                        <input 
                            style={{ display: 'none' }}
                            id="selectedfileid"
                            type="file" 
                            onChange={event => setBrowseFilePath(event.target.value)}
                          />
                          {uploadProgress?<>
                            <div style={{textAlign:'center'}}><CircularProgress size={28} /></div>
						                <br/>Wait..., It is uploading your file</>
                          :<>
                          <label htmlFor="selectedfileid">                            
                            <Button component="span" style={{backgroundColor:'#f9c07a',color:'#000', margin: 2}} size="small" variant="contained" >
                              Browse File
                            </Button>   
                            {
                              (browseFilePath && browseFilePath.length>0)?
                              <span style={{marginLeft:5}}>{browseFilePath}</span>
                              :null
                            }                        
                          </label>
                          </>}
                      </Box>
                    :
                      <div className="tblReport" style={{height: '62vh', width: '100%' }}>
                        <DataGrid
                          rows={rows}
                          columns={columns}
                          pageSize={50}
                          rowHeight={57}
                          rowsPerPageOptions={[50]}
                          ActionsComponent={()=>{alert('Hello')}}		
                          style={{fontSize:12}}	
                          // onRowClick={itm => selectRow(itm)}
                          onCellClick={handleOnCellClick}	
                          components={{
                            NoRowsOverlay: () => (
                              <Stack height="100%" alignItems="center" justifyContent="center">
                              <span style={{color:'#FF0000',fontWeight:'bold',marginTop:-1800}}>No record found!</span>
                              </Stack>
                            )}}	
                        />
                      </div>
                    }

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

        <Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

    </>
  );

});

export default CustomizedDialogs;